import React, { useState, useEffect, useContext } from "react";
export default function Notification(props) {
  useEffect(() => {
    console.log("Notification On mount :", props);
  }, []);
  return (
    <div>
      <p>Notification Page</p>
    </div>
  );
}
